import { useEffect, useMemo, useState } from 'react';
import { UserQueryInterface, useGetUsersQuery } from '../redux/api/users';
import { UserListInterface } from '../interfaces/User.interface';

const parseUser = (value: string | null): UserListInterface | null => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    console.warn("Failed to parse stored user", e);
    return null;
  }
};

export const usePersistedUser = (
  groupName: string,
  localStorageKey: string
): [UserListInterface | null, React.Dispatch<React.SetStateAction<UserListInterface | null>>, UserListInterface[] | undefined] => {
  const [selectedUser, setSelectedUser] = useState<UserListInterface | null>(null);

  const userQuery: UserQueryInterface = useMemo(() => ({
    groups__name: groupName,
  }), [groupName]);

  const { data: users } = useGetUsersQuery(userQuery);

  useEffect(() => {
    const storedUser = parseUser(localStorage.getItem(localStorageKey));
    if (storedUser && users?.results?.length) {
      const stillExists = users.results.find((u) => u.id === storedUser.id);
      if (stillExists) {
        setSelectedUser(storedUser);
      } else {
        setSelectedUser(null);
        localStorage.removeItem(localStorageKey);
      }
    }
  }, [users, localStorageKey]);

  useEffect(() => {
    if (selectedUser) {
      localStorage.setItem(localStorageKey, JSON.stringify(selectedUser));
    }
  }, [selectedUser, localStorageKey]);

  return [selectedUser, setSelectedUser, users?.results];
};
